<template>
  <div class="userinfo">
    <Card class="card">
      <div class="topTit">
        <p>基本信息</p>
      </div>
      <div class="userInfo">
        <div class="userImg">
          <Upload
            :action="uploadUrl"
            :show-upload-list="false"
            :on-success="handleSuccess"
            :format="['jpg', 'jpeg', 'png', 'bmp']"
            :on-format-error="formatError"
            :on-error="handleError"
            :headers="{ authtoken: authtoken }"
            :before-upload="beforeUpload"
          >
            <img :src="userInfo.avatarUrl" alt>
            <p class="changeTxt fontcursor">更换头像</p>
          </Upload>
        </div>
        <div>
          <span>账号名:</span>
          {{ userInfo.account }}
        </div>
        <div>
          <span>创建时间:</span>
          {{ userInfo.createTime }}
        </div>
        <div>
          <span>用户角色:</span>
          {{ name }}
        </div>
        <div>
          <span>密码:</span> ********
          <i
            class="icon tsit icon_bianji point"
            @click="link('/user/account/infoIndex/pwd', userInfo)"
          ></i>
        </div>
      </div>
      <router-view></router-view>
    </Card>
  </div>
</template>

<script>
import { getUserInfo } from "@/api/user";
import { log } from "util";
export default {
  data() {
    return {
      name: "",
      str: "",
      userInfo: {
        id: 1,
        account: "张章",
        registerData: "2020/12/14 13:48:5",
        phone: "17662453180",
        email: "1738093828@qq.com",
        password: "zww123456",
        avatarUrl: null,
        uploadUrl: null,
        authtoken: null
      }
    };
  },
  created() {
    this.getUserInfo();
    this.uploadUrl = _URL.UPLOAD_HEAD_URL; //上传图片接口
    this.authtoken = "Bearer " + _Cookie.get("adminauth"); //上传图片的token
  },
  methods: {
    // 获取用户信息
    getUserInfo() {
      getUserInfo().then(res => {
        console.log("用户信息", res);
        this.userInfo = res.data.data;
        this.name = res.data.data.role.name;
        this.$store.commit("setUserImg", this.userInfo.avatarUrl);
        console.log("角色", this.name);
        // 默认图片
        if (!this.userInfo.avatarUrl) {
          this.userInfo.avatarUrl = require("@/assets/img/default_avatar.png");
        }
      });
    },
    uploadSuccess(response, file, fileList) {
      this.addForm.accessory = response.data;
    },
    link(path, userInfo) {
      this.$router.push({
        path: path,
        query: { userId: userInfo.id }
      });
    },
    linkVerify(path, userInfo) {
      this.$router.push({
        path: path,
        query: { userInfo: userInfo }
      });
    },
    handleSuccess(response, file, fileList) {
      this.$set(this.userInfo, "avatarUrl", response.data);
      localStorage.setItem("adminAvatar", response.data);
      this.$store.commit("setUserImg", response.data);
      this.getUserInfo();
      this.$Message.success("头像更换成功")
    },
    handleError(error, file, fileList) {
      console.log("图片上传失败", error);
    },
    beforeUpload(file) {
      if(file.size/1024 > 10240) {
        this.$Message.success("文件大小不得超过10MB")
        return false
      }
    },
    formatError(error, file, fileList) {
      this.$Notice.warning({
        title: "文件格式错误",
        desc: "文件仅支持：jpg、jpeg、png、bmp格式",
      });
    },
  },
  computed: {
    /**
     * 密码加密转换
     */
    password_C() {
      const pwdLength = this.userInfo.password.length;
      for (let i = 0; i < pwdLength; i++) {
        this.str = this.str + "*";
      }
      return this.str;
    }
  }
};
</script>

<style lang="scss" scoped>
.userinfo {
  .card {
    min-height: calc(100vh - 150px);
    overflow: auto;
    font-size: 14px;
    color: #2f4061;
    .topTit {
      font-size: 16px;
      font-family: MicrosoftYaHeiSemibold;
      color: #2f4061;
      font-weight: bold;
      border-bottom: 1px solid #ebedf0;
      box-sizing: border-box;
      padding: 10px 0px;
    }
    .userInfo {
      margin-top: 30px;
      .userImg {
        width: 124px;
        height: 124px;
        border-radius: 62px;
        box-sizing: border-box;
        margin-left: 20px;
        margin-bottom: 20px;
        position: relative;
        overflow: hidden;
        img {
          width: 100%;
          height: 124px;
        }
        .changeTxt {
          color: #ffffff;
          width: 124px;
          height: 26px;
          background: rgba(0, 0, 0, 0.39);
          position: absolute;
          bottom: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 11px;
        }
      }
      div {
        height: 35px;
        line-height: 35px;
        span {
          color: #67799c;
          display: inline-block;
          width: 80px;
          text-align: right;
          margin-right: 10px;
        }
        i {
          color: #0081ff;
          margin-left: 3px;
        }
        .point {
          cursor: pointer;
        }
      }
    }
  }
}
</style>